import {
  Checkbox as MuiCheckBox,
  FormControlLabel,
  makeStyles,
} from "@material-ui/core";

interface CheckboxProps {
  label: string;
  checked?: boolean;
  setChecked: (checked: boolean) => void;
  className: string;
}

const useStyles = makeStyles({
  root: {
    margin: 0,
    padding: 0,
  },
  label: {
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "normal",
    paddingLeft: 8,
  },
});

const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps) => {
  const classes = useStyles();

  const handleChange = (_event: any, checked: boolean) => {
    props.setChecked(checked);
  };

  return (
    <FormControlLabel
      className={props.className}
      classes={{ root: classes.root, label: classes.label }}
      control={
        <MuiCheckBox
          classes={{ root: classes.root }}
          checked={props.checked ? props.checked : false}
          onChange={handleChange}
          color="primary"
        />
      }
      label={props.label}
    />
  );
};

export default Checkbox;
